<template>
  <div class=" title-box">
    <div class="wh-flex-between title-unit">
      <div class="title">
        {{ title }}
      </div>
      <div class="is-trace">
        <van-icon class="icon" name="certificate" /><span class="text">可追溯</span>
      </div>
    </div>
    <div class="divider" />
  </div>
</template>

<script>
export default {
  name: 'UnitTitle',
  props: {
    title: {
      type: String,
      default: '标题'
    }
  }
}
</script>

<style lang='less' scoped>
.title-box {
  margin: 10px 0;
  line-height: 1;
  font-family: Microsoft YaHei;
  .title-unit {
    background: linear-gradient(#20caa0,#20caa0) left center no-repeat;
    background-size: 4px 100%;
  }
  .divider {
    height: 1px;
    width: 100%;
    background: #D6D6D6;
    margin-top: 15px;
  }
  .title {
    padding-left: 10px;
    font-size: 16px;
    font-weight: 400;
    color: #323332;
  }
  .is-trace {
    .icon {
      font-size: 14px;
      color: #20caa0;
    }
    .text {
      margin-left: 10px;
      font-size: 12px;
      font-weight: 400;
      color: #000000;
    }
  }
}
</style>
